module.exports = __webpack_public_path__ + "img/btn-light.70e99fa6.png";